import { z } from "zod";

import { MetaDataSchema } from "@/types/meta-data";

import { ProductSchema } from "./product";

import { PriceSchema } from "./price";

export const SubscriptionSchema = z.object({
	id: z.number(),
	product: ProductSchema,
	price: PriceSchema,
	startedAt: z.date(),
	endedAt: z.date().nullable(),
	canceledAt: z.date().nullable(),
	canceledBy: z.number().nullable().optional(),
	stripeSubscriptionId: z.string().nullable().optional(),
});

export const SubscriptionResponseSchema = z.object({
	data: z.array(SubscriptionSchema),
	meta: MetaDataSchema,
});

export type Subscription = z.infer<typeof SubscriptionSchema>;

export type SubscriptionResponse = z.infer<typeof SubscriptionResponseSchema>;
